module.exports = __webpack_public_path__ + "img/13.4583bae5.jpg";